import React, { useEffect, useState , useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion , AnimatePresence } from 'framer-motion';
import axios from 'axios';
import TopBar from '../components/TopBar';
import Header from '../components/headerfooter/Header';
import Footer from '../components/headerfooter/Footer';
import MobileFooter from '../components/MobileFooter';
import Loader from '../components/Loader';
import {  FaUserFriends, FaUsers,FaBolt, FaGift, FaYoutube, FaInstagram, FaFacebook, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { FaUserGraduate, FaClock, FaStar ,FaTag } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { IMAGE_URL, REACT_APP_API_PORT } from '../Api';
import { NavLink } from "react-router-dom";
import ReactPlayer from 'react-player';
import { Navigation, Autoplay } from "swiper/modules";
import { MdTravelExplore } from 'react-icons/md';
import { SiOpenai } from 'react-icons/si';
import { BiConversation } from 'react-icons/bi';
import { getDecryptedData } from '../config/crypto';
import WhatsAppChatButton from '../components/WhatsAppChatButton';
import { Helmet } from 'react-helmet';
import MembershipCard2 from './socialpage/component/MembershipCard2';
import { SiThreads } from "react-icons/si";
import "swiper/css";
import "swiper/css/navigation";
import AiWorkshopPopup from "../components/AiWorkshopPopup";

function highlightMultipleKeywords(text, keywords) {
  const regex = new RegExp(`(${keywords.join("|")})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    keywords.includes(part) ? (
      <span
        key={index}
        className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent"
      >
        {part}
      </span>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    )
  );
}


const Home3 = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]); 
  const [additionalData, setadditionalData] = useState([]);
  const [subscriptionData, setsubscriptionData] = useState([]);
  const [workshops, setWorkshop] = useState([])
  const [trainings, setTraining] = useState([])
  const [discount, setDiscount] = useState([]);
 const [showPopup, setShowPopup] = useState(false);

  

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/nextfutureai_homepage_details`
      );
      if (res.data.status) {
        setData(res.data.data)
        if (res.data.additionalData) {
          setadditionalData(res.data.additionalData)
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMetaData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Nextfutureai Homepage`
      );
      if (res.data.status) {
        setMeta(res.data.data)
        
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const cards = [
  {
    title: "3D Music Vibes",
    tag: "GEMINI",
    img: "https://nextfutureai.com/nodebackend/backend/uploads/images/image-prompt-1764842316828-Gemini_Generated_Image_by1mvbby1mvbby1m.JPEG",
  },
  {
    title: "Frost Tiger Warrior",
    tag: "CHATGPT",
    img: "https://nextfutureai.com/nodebackend/backend/uploads/images/image-prompt-1760081599715-Donatello%E2%80%99s-Cool-Hideout.JPEG",
  },
  {
    title: "Rajasthani Poshak Portrait",
    tag: "Premium",
    img: "https://nextfutureai.com/nodebackend/backend/uploads/images/image-prompt-1764684253597-Gemini_Generated_Image_x1ukfix1ukfix1uk.JPEG",
  },
  {
    title: "Bollywood Dream Look",
    tag: "Premium",
    img: "https://nextfutureai.com/nodebackend/backend/uploads/images/image-prompt-1760076875391-ChatGPT-Image-Oct-10,-2025,-11_43_57-AM.JPEG",
  },
  {
    title: "Winter Home Vibes",
    tag: "GEMINI",
    img: "https://nextfutureai.com/nodebackend/backend/uploads/images/image-prompt-1764684253597-Gemini_Generated_Image_x1ukfix1ukfix1uk.JPEG",
  },
  {
    title: "Magical Aladdin Ride",
    tag: "CHATGPT",
    img: "https://nextfutureai.com/nodebackend/backend/uploads/images/image-prompt-1764842316828-Gemini_Generated_Image_by1mvbby1mvbby1m.JPEG",
  },
];


  const [openIndex, setOpenIndex] = useState(0);


  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const slideVariants = {
  initial: (direction) => ({
    x: direction > 0 ? 80 : -80,
    opacity: 0,
  }),
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.45,
      ease: "easeOut",
    },
  },
  exit: (direction) => ({
    x: direction > 0 ? -80 : 80,
    opacity: 0,
    transition: {
      duration: 0.35,
      ease: "easeIn",
    },
  }),
};

 const students = [
    "6000+ students",
    // "8000+ students",
    "7000+ students",
    "4000+ students",
    "5000+ students",
    "5000+ students",
    "7000+ students",
    "5000+ students",
    "10000+ students",
    "8000+ students",
    "7000+ students",
    "9000+ students",
  ];

  useEffect(() => {
    fetchData();
    fetchMetaData();
    getWorkshopData();
    getTrainingData();
  }, []);


  const getSubscriptionData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/activesubscription`
      );
      setIsLoading(false);
      setsubscriptionData(res.data.data);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

   const getWorkshopData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/active-workshop-details-page`);
      setIsLoading(false);
      if (res.data.status) {
        setWorkshop(res.data.data);
      }

    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const parseValue = (value) => {
  if (value === null || value === undefined) {
    return { number: 0, suffix: "+" };
  }

  const stringValue = String(value); // 👈 always convert to string

  if (stringValue.includes("K")) {
    return { number: parseFloat(stringValue) * 1000, suffix: "K+" };
  }

  if (stringValue.includes("M")) {
    return { number: parseFloat(stringValue) * 1000000, suffix: "M+" };
  }

  return { number: parseFloat(stringValue) || 0, suffix: "+" };
};


      const CountUp = ({ value, duration = 1500 }) => {
        const { number, suffix } = parseValue(value);
        const [count, setCount] = useState(0);

        useEffect(() => {
          let start = 0;
          const increment = number / (duration / 16);

          const timer = setInterval(() => {
            start += increment;
            if (start >= number) {
              setCount(number);
              clearInterval(timer);
            } else {
              setCount(start);
            }
          }, 16);

          return () => clearInterval(timer);
        }, [number, duration]);

        const formatNumber = (val) => {
          if (number >= 1000000) {
            const num = val / 1000000;
            return Number.isInteger(num) ? num.toFixed(0) : num.toFixed(1);
          }
          if (number >= 1000) {
            return Math.floor(val / 1000);
          }
          return Math.floor(val);
        };

        const display = formatNumber(count);


        return (
          <span>
            {display}
            {suffix}
          </span>
        );
      };

  const getTrainingData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/active-training-details-page`);
      setIsLoading(false);
      if (res.data.status) {
        setTraining(res.data.data);
      }

    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const getYearlyDiscountData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/get-yearly-discount`
      );
      setIsLoading(false);
      setDiscount(res.data.data);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

 

  const TABS = ["Courses", "Trainings", "Workshops", "Memberships"];
    const [activeTab, setActiveTab] = useState("Courses");
    const [prevIndex, setPrevIndex] = useState(0);

    const activeIndex = TABS.indexOf(activeTab);
    const direction = activeIndex > prevIndex ? 1 : -1;

    const handleTabChange = (tab) => {
      setPrevIndex(activeIndex);
      setActiveTab(tab);
    };


    const filteredData =
    activeTab === "Courses"
        ? additionalData?.courseData?.slice(0, 6)
        : [];

    const filteredWorkshop =
    activeTab === "Workshops"
        ? workshops?.slice(0, 6)
        : [];
    
    const filteredtraining =
    activeTab === "Trainings"
        ? trainings?.slice(0, 6)
        : [];

      const VIEW_ALL_ROUTES = {
    Courses: "/courses",
    Trainings: "/trainings",
    Workshops: "/workshops",
    Memberships: "/memberships",
    };

  
  const tabsContainerRef = useRef(null);
  const tabRefs = useRef([]);
  const [pill, setPill] = useState({ width: 0, x: 0 });


  useEffect(() => {
  const index = TABS.indexOf(activeTab);
  const tabEl = tabRefs.current[index];
  const containerEl = tabsContainerRef.current;

  if (tabEl && containerEl) {
    //const containerPadding = 8; // p-2 = 8px
    const containerPadding = window.innerWidth < 640 ? 12 : 8;


    setPill({
      width: tabEl.offsetWidth,
      x: tabEl.offsetLeft - containerPadding,
    });
  }
  }, [activeTab]);

  useEffect(() => {
    getSubscriptionData()
    getYearlyDiscountData()
  }, [])

  const sortedData = [...subscriptionData].sort((a, b) => {
    if (subscriptionData.length === 3) {
      if (a.isPopular === "Yes") return -1;
      if (b.isPopular === "Yes") return 1;
      return a.title.localeCompare(b.title);
    }
    return 0;
  });

  let finalData = sortedData;

  // If exactly 3 plans and only one is popular
  if (subscriptionData.length === 3) {
    const popularIndex = sortedData.findIndex(item => item.isPopular === "Yes");

    if (popularIndex !== -1 && sortedData.filter(item => item.isPopular === "Yes").length === 1) {
      const popularPlan = sortedData.splice(popularIndex, 1)[0];
      finalData = [sortedData[0], popularPlan, sortedData[1]];
    }
  }

  const sectionReveal = {
    hidden: { opacity: 0, y: 70 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  useEffect(() => {
  // Pehla popup 2 minute baad
  const firstTimer = setTimeout(() => {
    setShowPopup(true);

    // Fir har 5 minute baad
    const interval = setInterval(() => {
      setShowPopup(true);
    }, 5 * 60 * 1000); // 5 min

    // cleanup interval
    return () => clearInterval(interval);
  }, 1 * 60 * 1000); // 1 min

  // cleanup timeout
  return () => clearTimeout(firstTimer);
}, []);

  const handleOpenPrompt = async(link) =>{
    const token = getDecryptedData("token")
    if(token){
      window.location.href = link
    }else{
      navigate("/login")
    }
  }

  const tools = [
  { name: "ChatGPT", icon: "/icons/chatgpt.png" },
  { name: "Gemini", icon: "/icons/gemini.png" },
  { name: "n8n", icon: "/icons/n8n.png" },
  { name: "Perplexity", icon: "/icons/perplexity.png" },
  { name: "Claude", icon: "/icons/Claude.png" },
  { name: "VEO3", icon: "/icons/veo3.png" },
  { name: "Copilot", icon: "/icons/Copilot.png" },
  
   { name: "ChatGPT", icon: "/icons/chatgpt.png" },
  { name: "Gemini", icon: "/icons/gemini.png" },
  { name: "n8n", icon: "/icons/n8n.png" },
  { name: "Perplexity", icon: "/icons/perplexity.png" },
  { name: "Claude", icon: "/icons/Claude.png" },
  { name: "VEO3", icon: "/icons/veo3.png" },
  { name: "Copilot", icon: "/icons/Copilot.png" },
];

const tools1 = [
 { name: "Lovable", icon: "/icons/Lovable.png" },
  { name: "Loomtool", icon: "/icons/Loomtool.png" },
  { name: "Higgsfield", icon: "/icons/Higgsfield.png" },
  { name: "Runway", icon: "/icons/Runway.png" },
  { name: "NotebookLM", icon: "/icons/NotebookLM.png" },
  { name: "Midjourney", icon: "/icons/Midjourney.png" },
  { name: "Heygen", icon: "/icons/heygen.png" },
  
  { name: "Lovable", icon: "/icons/Lovable.png" },
  { name: "Loomtool", icon: "/icons/Loomtool.png" },
  { name: "Higgsfield", icon: "/icons/Higgsfield.png" },
  { name: "Runway", icon: "/icons/Runway.png" },
  { name: "NotebookLM", icon: "/icons/NotebookLM.png" },
  { name: "Midjourney", icon: "/icons/Midjourney.png" },
  { name: "Heygen", icon: "/icons/heygen.png" },
];

const marqueeTools = [...tools, ...tools, ...tools];
const marqueeTools1 = [...tools1, ...tools1, ...tools1];

// const ITEMS_PER_SLIDE = 3;
const [[page, direction1], setPage] = useState([0, 0]);
const [[page2, direction2], setPage2] = useState([0, 0]);
// const totalSlides = Math.ceil(
//   (additionalData?.learnersData?.length || 0) / ITEMS_PER_SLIDE
// );

const ITEMS_PER_SLIDE1 = 1;
 const totalPages = Math.ceil(
  additionalData?.learnersData?.length / ITEMS_PER_SLIDE1
);
const paginate1 = (newDirection) => {
  setPage2(([p]) => {
    let next = p + newDirection;
    if (next < 0) next = totalPages  - 1;
    if (next >= totalPages ) next = 0;
    return [next, newDirection];
  });
};

const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) =>
  Math.abs(offset) * velocity;

const paginate = (newDirection) => {
  setPage([page + newDirection, newDirection]);
};

  return (
    <div className='overflow-hidden'>
    {/* {showPopup && (
        <AiWorkshopPopup onClose={() => setShowPopup(false)} />
      )} */}
     <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
      <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
    
      <Header />
      {/* 🔥 Home Page Announcement Bar */}
       
      {/* <WhatsAppChatButton /> */}


  <motion.section
        variants={sectionReveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="relative overflow-hidden bg-black text-white
        pt-44 sm:pt-48 md:pt-[220px]
        pb-[90px] md:pb-[110px]
        font-sans"
      >

      {/* CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">

        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 px-5 py-2 rounded-full
          bg-white/5 border border-white/10
          text-sm text-gray-300 mb-6 md:mb-8"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-sparkles w-4 h-4 text-[#e12f5b]"
            aria-hidden="true"
          >
            <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
            <path d="M20 2v4" />
            <path d="M22 4h-4" />
            <circle cx="4" cy="20" r="2" />
          </svg>
           {data?.section1_top_badge}
        </div>

        {/* Heading */}
      <h1
          className="
            text-[38px]              /* ✅ ONLY mobile */
            md:text-[76px]           /* desktop same */
            font-extrabold
            leading-tight
            tracking-tight
          "
        >
        <span className="block"> {data?.section1_heading}</span>

        <span className="block">
          {data?.section1_heading1}
          <span className="ml-2 gradient-text"> {data?.section1_heading2}</span>
        </span>
      </h1>



        {/* Description */}
      <p
          className="
            mt-6
            mx-auto
            text-base              /* ✅ ONLY mobile */
            md:text-xl               /* desktop same */
            text-gray-400
            font-medium
            leading-relaxed
            max-w-[42rem]
          "
        >
         {data?.section1_description || 
        "Join the free premium community for 2000+ prompts, exclusive courses & daily AI updates. All in one place.."}
        </p>

        {/* CTA BUTTONS */}
      <div
  className="
    mt-8 md:mt-10
    flex flex-col md:flex-row
    items-center justify-center
    gap-3 md:gap-4
  "
>
  <a
    href={data?.section1_button_link}
    target="_blank"
    rel="noopener noreferrer"
  >
    <button
      className="
        h-12
        w-[240px]          /* ✅ same width */
        text-sm
        font-semibold text-white
        rounded-full
        bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
        flex items-center justify-center gap-2
        hover:scale-105 transition-all
        shadow-[0_0_32px_rgba(245,95,255,0.30)]
        group
      "
    >
      {data?.section1_button_name}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5 transition-transform group-hover:translate-x-1"
      >
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
      </svg>
    </button>
  </a>

  <a
    href={data?.section1_button2_link}
    target="_blank"
    rel="noopener noreferrer"
  >
    <button
      className="
        btn-outline
        h-12
        w-[240px]          /* ✅ same width */
        text-sm
        text-gray-300
        !rounded-full
        hover:text-white
        hover:scale-105
        shadow-md
      "
    >
      {data?.section1_button2_name}
    </button>
  </a>
</div>




        {/* STATS */}
        <div
          className="
                mt-14 md:mt-20
                grid grid-cols-2
                md:flex
                md:max-w-[64rem]
                md:mx-auto
                md:justify-between

                gap-4 md:gap-6        /* 🔥 mobile gap smaller */
                px-1 sm:px-2         /* 🔥 almost full width mobile */
                md:px-10 lg:px-12
              "

              >

          {[
  { value: data?.section1_instagram_followers ?? 0, label: "Total Followers" },
  { value: data?.section1_youtube_subscribers ?? 0, label: "Account Reached (Last 90 Days)" },
  { value: data?.section1_members ?? 0, label: "AI Community Learners" },
  { value: data?.section1_views ?? 0, label: "Interactions (Last 90 Days)" },
].map((item, i) => (
            <div
              key={i}
              className="
              w-full max-w-[240px]
              md:w-[200px]
              mx-auto
             rounded-2xl
              bg-white/5 backdrop-blur-md
              border border-white/10
              px-4 py-4
              md:px-6 md:py-6
              text-center
            "

            >
              <h3
                className="text-[22px] sm:text-[26px] md:text-[32px]
                font-extrabold
                gradient-text"
              >
                <CountUp value={item.value ?? 0} />
              </h3>

              <p className="mt-1.5 text-[12px] md:text-[13px] text-gray-400 leading-snug">
                {item.label}
              </p>
            </div>
          ))}
        </div>

      </div>
    </motion.section>

          <motion.section
          variants={sectionReveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="relative bg-black text-white py-20 px-4 sm:py-28 overflow-hidden"
        >
            
              <div className="relative z-10 max-w-6xl mx-auto text-center">
                {/* Title */}
                <h2
                className="
                  text-[36px]          /* 🔥 mobile bigger */
                  sm:text-4xl          /* tablet same */
                  md:text-5xl          /* desktop same */
                  font-extrabold
                  tracking-tight
                  mb-4 sm:mb-6
                  leading-tight
                "
              >
                {data?.section2_heading}{" "}
                <span className="gradient-text drop-shadow-lg">
                  {data?.section2_heading2}
                </span>{" "}
              {data?.section2_heading3}
              </h2>
                <p className="text-base sm:text-xl md:text-2xl text-gray-400 mb-8 sm:mb-14 max-w-md sm:max-w-2xl mx-auto">
                  {data?.section2_description}
                </p>
                <div className="relative mx-auto w-full aspect-video max-w-full sm:max-w-5xl rounded-2xl sm:rounded-3xl overflow-hidden border border-white/10 shadow-2xl backdrop-blur-md bg-white/5">
                  {data?.section2_youtube_link && (
                    <ReactPlayer
                      url={data.section2_youtube_link}
                      width="100%"
                      height="100%"
                      controls
                      className="absolute top-0 left-0"
                    />
                  )}
                </div>
                {/* Stats Pills */}
              {/* Stats Pills */}
              <div className="mt-10 flex flex-wrap justify-center gap-4">
              {[
                {
                  label: "Learners",
                  value: data.section2_badge1,
                  icon: (
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-5 h-5 text-[#ff3366]"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <circle cx="9" cy="7" r="4" />
                    </svg>
                  ),
                },
                {
                  label: "Rating",
                  value: data.section2_badge2,
                  icon: (
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-5 h-5 text-[#ff3366]"
                    >
                      <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                    </svg>
                  ),
                },
                {
                  label:  data.section2_badge3,
                  value: "",
                  icon: (
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-5 h-5 text-[#ff3366]"
                    >
                      <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                      <circle cx="12" cy="8" r="6" />
                    </svg>
                  ),
                },
              ].map(({ label, value, icon }, i) => (
                <div
                  key={i}
                  className="
                    flex items-center gap-2.5
                    bg-white/5
                    border border-white/15
                    backdrop-blur-md
                    rounded-full
                    px-6 py-3
                    text-base
                    shadow-xl
                    hover:bg-white/10
                    transition
                  "
                >
                  {icon}
                  {value && <span className="font-semibold text-white">{value}</span>}
                  <span className="text-gray-300 whitespace-nowrap">{label}</span>
                </div>
              ))}
            </div>
              </div>
            </motion.section>

           

    <motion.section
        variants={sectionReveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="relative py-24 bg-black text-white overflow-hidden"
      >

        

        <div className="relative z-10 max-w-[90rem] mx-auto px-4">

          {/* 🧠 HEADING */}
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight">
              { data?.section3_heading}{" "}
              <span className="gradient-text">
               { data?.section3_heading2}
              </span>
            </h2>
            <p className="mt-6 max-w-3xl mx-auto text-gray-400 text-lg md:text-xl leading-relaxed">
                 { data?.section3_subheading}
                </p>  
          </div>

          

          <div className="relative mx-auto mb-16 w-fit">
        <div
          ref={tabsContainerRef}
          className="
            relative flex items-center
           gap-1.5 sm:gap-1
            bg-[#0a0a0a] backdrop-blur-xl
            rounded-full
            px-3 py-2 sm:p-2
            
            overflow-x-auto
            scrollbar-hide
            border border-white/10
          "
            >
          {/* 🔥 ACTIVE PILL */}
          <motion.div
            animate={{ width: pill.width, x: pill.x }}
            transition={{ type: "spring", stiffness: 420, damping: 34 }}
            className="
              absolute top-1.5 bottom-1.5
              rounded-full
              bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
              shadow-[0_0_28px_rgba(245,95,255,0.55)]
              
            "
          />

          {/* TAB BUTTONS */}
          {TABS.map((tab, i) => (
            <button
        key={tab}
        ref={(el) => (tabRefs.current[i] = el)}
        onClick={() => handleTabChange(tab)}
        className={`
          relative z-10
          h-9 sm:h-10 md:h-9        /* 🔥 desktop thoda chhota */
          px-3 sm:px-5 md:px-4     /* 🔥 desktop compact */
          flex items-center justify-center
          text-[11px] sm:text-[13px] md:text-[14px]
          font-semibold            /* bold → semi-bold (cleaner) */
          uppercase leading-none
          rounded-full
          whitespace-nowrap
          transition-colors duration-300
          ${
            activeTab === tab
              ? "text-white"
              : "text-gray-300 hover:text-white"
          }
        `}
      >
        {tab}
      </button>

          ))}
        </div>
      </div>

          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={activeTab}
              custom={direction}
              variants={slideVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >

          {/* ================= COURSE ================= */}
          {activeTab === "Courses" && (
      <>
        {/* ================= MOBILE SLIDER ================= */}
        <div className="block lg:hidden relative">

          {/* LEFT ARROW */}
          <button className="course-prev absolute left-2 top-1/2 -translate-y-1/2 z-20 w-9 h-9 rounded-full bg-black/60 border border-white/20 text-white backdrop-blur">
            ‹
          </button>

          {/* RIGHT ARROW */}
          <button className="course-next absolute right-2 top-1/2 -translate-y-1/2 z-20 w-9 h-9 rounded-full bg-black/60 border border-white/20 text-white backdrop-blur">
            ›
          </button>

          <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            prevEl: ".course-prev",
            nextEl: ".course-next",
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          loop={true}
          speed={700}
          spaceBetween={16}
          slidesPerView={1}
          className="px-4"
        >
            {filteredData?.map((c, i) => (
              <SwiperSlide key={i}>

                <div
                  className="
                    group flex flex-col
                    bg-[#0a0a0a]
                    border border-white/10
                    rounded-2xl overflow-hidden
                    w-full
                  "
                >
                  {/* IMAGE */}
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={IMAGE_URL + c?.course_id?.banner}
                      alt={c?.course_id?.course_name}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  </div>

                  {/* CONTENT */}
                  <div className="flex flex-col flex-1 p-5 space-y-3">
                    <h3 className="text-lg font-bold leading-tight">
                      {c?.course_id?.course_name}
                    </h3>

                    {/* <p className="text-sm text-gray-300 line-clamp-2">
                      {c?.course_id?.section1_description}
                    </p> */}

                     <div className="flex items-center justify-between text-sm text-neutral-300 border-t border-white/10 pt-3.5">
                    <div className="flex items-center gap-2">
                      <FaUserGraduate className="text-emerald-400" />
                      <span> {c?.course_id?.course_student}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <FaStar className="text-yellow-400" />
                      {/* <span>{c.course_rating}</span> */}
                      <span>{Number(c?.course_id?.course_rating)?.toFixed(1)}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <FaTag  className="text-blue-400" />
                      {/* <span>1-2 hours</span> */}
                      {/* {duration[i]} */}
                      {c?.course_id?.discount}% OFF
                    </div>
                  </div>

                    <NavLink
                    to={`/courses/${c?.course_id?.course_name
                      ?.toLowerCase()
                      .replace(/[^a-z0-9]+/gi, "-")}`}
                    state={{ id: c?.course_id?._id }}
                    className="
                      group
                      mt-4
                      flex items-center justify-center gap-2
                      py-3 px-5
                      rounded-full
                      font-semibold text-white
                      bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                      hover:scale-[1.02]
                      transition-all
                    "
                  >
                    Enroll Now

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="w-5 h-5 transition-transform group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </NavLink>

                  </div>
                </div>

              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* ================= DESKTOP GRID (UNCHANGED) ================= */}
        <div
          className="
            hidden lg:grid
            grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
            gap-x-6 gap-y-6
            mx-0 lg:mx-14
          "
        >
          {filteredData?.map((c, i) => (
            <div
              key={i}
              className="
                group flex flex-col
                bg-[#0a0a0a] backdrop-blur-xl
                border border-white/10
                rounded-2xl overflow-hidden
                transition-all duration-300
                hover:shadow-[0_0_30px_rgba(245,95,255,0.25)]
                hover:-translate-y-1
                w-full w-[380px]
                mx-0 lg:mx-auto
              "
            >
              {/* IMAGE */}
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={IMAGE_URL + c?.course_id?.banner}
                  alt={c?.course_id?.course_name}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>

              {/* CONTENT */}
              <div className="flex flex-col flex-1 p-5 space-y-3">
                <h3 className="text-lg font-bold leading-tight">
                  {c?.course_id?.course_name}
                </h3>

                {/* <p className="text-sm text-gray-300 line-clamp-2">
                  {c?.course_id?.section1_description}
                </p> */}

                 <div className="flex items-center justify-between text-sm text-neutral-300 border-t border-white/10 pt-3.5">
                    <div className="flex items-center gap-2">
                      <FaUserGraduate className="text-emerald-400" />
                      <span> {c?.course_id?.course_student}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <FaStar className="text-yellow-400" />
                      {/* <span>{c.course_rating}</span> */}
                      <span>{Number(c?.course_id?.course_rating)?.toFixed(1)}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <FaTag  className="text-blue-400" />
                      {/* <span>1-2 hours</span> */}
                      {/* {duration[i]} */}
                      {c?.course_id?.discount}% OFF
                    </div>
                  </div>

              <NavLink
              to={`/courses/${c?.course_id?.course_name
                ?.toLowerCase()
                .replace(/[^a-z0-9]+/gi, "-")}`}
              state={{ id: c?.course_id?._id }}
              className="
                group
                mt-4
                flex items-center justify-center gap-2
                text-center py-3 px-5
                rounded-full
                font-semibold text-white
                bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                hover:scale-[1.02]
                transition-all
              "
            >
              Enroll Now

              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="w-5 h-5 transition-transform group-hover:translate-x-1"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </NavLink>

              </div>
            </div>
          ))}
        </div>
      </>
      )}



          {/* ================= MEMBERSHIP ================= */}
        {activeTab === "Memberships" && (
      <>
        {/* ================= MOBILE SLIDER ================= */}
        <div className="block lg:hidden relative">

          {/* LEFT ARROW */}
          <button className="membership-prev absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/20 text-white">
            ‹
          </button>

          {/* RIGHT ARROW */}
          <button className="membership-next absolute right-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/20 text-white">
            ›
          </button>

          
            <Swiper
            modules={[Navigation, Autoplay]}
              navigation={{
              prevEl: ".membership-prev",
              nextEl: ".membership-next",
            }}
            autoplay={{
              delay: 2500,              // 👈 2.5 sec me slide change
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            loop={true}                 // 👈 infinite slider
            spaceBetween={16}
            slidesPerView={1}
            className="px-4"
          >
            {/* 🔥 Agar MembershipCard2 internally multiple cards show karta hai
                toh simply ek slide me hi render kar do */}
            <SwiperSlide>
              <MembershipCard2 />
            </SwiperSlide>

          </Swiper>
        </div>

        {/* ================= DESKTOP VIEW (UNCHANGED) ================= */}
        <div className="hidden lg:block mt-12">
          <MembershipCard2 />
        </div>
      </>
      )}



          {/* ================= WORKSHOP ================= */}
          {activeTab === "Workshops" && (
      <>
        {/* ================= MOBILE SLIDER ================= */}
        <div className="block lg:hidden relative">

          {/* LEFT ARROW */}
          <button className="workshop-prev absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/20 text-white">
            ‹
          </button>

          {/* RIGHT ARROW */}
          <button className="workshop-next absolute right-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/20 text-white">
            ›
          </button>

        
            <Swiper
            modules={[Navigation, Autoplay]}
              navigation={{
               prevEl: ".workshop-prev",
              nextEl: ".workshop-next",
            }}
            autoplay={{
              delay: 2500,              // 👈 2.5 sec me slide change
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            loop={true}                 // 👈 infinite slider
            spaceBetween={16}
            slidesPerView={1}
            className="px-4"
          >
            {filteredWorkshop?.map((event) => (
              <SwiperSlide key={event._id}>

                <div
                  className="
                    group flex flex-col
                    bg-[#0a0a0a]
                    border border-white/10
                    rounded-2xl overflow-hidden
                  "
                >
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={IMAGE_URL + event.image}
                      alt={event.title}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  </div>

                  <div className="flex flex-col flex-1 p-5 space-y-3">
                    <h3 className="text-lg font-bold">{event.title}</h3>

                    <p className="text-sm text-gray-300 line-clamp-2">
                      {event.description}
                    </p>

                    <a
                    href={event.button_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
                      group
                      mt-auto
                      flex items-center justify-center gap-2
                      py-3 px-5
                      rounded-full
                      font-semibold text-white
                      bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                      hover:scale-[1.02]
                      transition-all
                    "
                  >
                    Register Now

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="w-5 h-5 transition-transform group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </a>

                  </div>
                </div>

              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* ================= DESKTOP GRID (UNCHANGED) ================= */}
        <div
          className="
            hidden lg:grid
            grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
            gap-x-6 gap-y-6
            mx-0 lg:mx-14
          "
        >
          {filteredWorkshop?.map((event) => (
            <div
              key={event._id}
              className="
                group flex flex-col
                bg-[#0a0a0a] backdrop-blur-xl
                border border-white/10
                rounded-2xl overflow-hidden
                transition-all duration-300
                hover:shadow-[0_0_30px_rgba(245,95,255,0.25)]
                hover:-translate-y-1
                w-full w-[380px]
                mx-0 lg:mx-auto
              "
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={IMAGE_URL + event.image}
                  alt={event.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
              </div>

              <div className="flex flex-col flex-1 p-5 space-y-3">
                <h3 className="text-lg font-bold">{event.title}</h3>

                <p className="text-sm text-gray-300 line-clamp-2">
                  {event.description}
                </p>

                <a
                href={event.button_link}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  group
                  mt-auto
                  flex items-center justify-center gap-2
                  py-3 px-5
                  rounded-full
                  font-semibold text-white
                  bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                  hover:opacity-90
                  transition
                "
              >
                Register Now

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="w-5 h-5 transition-transform group-hover:translate-x-1"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </a>

              </div>
            </div>
          ))}
        </div>
      </>
      )}



          {/* ================= TRAINING ================= */}
          {activeTab === "Trainings" && (
      <>
        {/* ================= MOBILE SLIDER ================= */}
        <div className="block lg:hidden relative">

          {/* LEFT ARROW */}
          <button className="training-prev absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/20 text-white">
            ‹
          </button>

          {/* RIGHT ARROW */}
          <button className="training-next absolute right-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-black/70 border border-white/20 text-white">
            ›
          </button>

         
             <Swiper
            modules={[Navigation, Autoplay]}
              navigation={{
              prevEl: ".training-prev",
              nextEl: ".training-next",
            }}
            autoplay={{
              delay: 2500,              // 👈 2.5 sec me slide change
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            loop={true}                 // 👈 infinite slider
            spaceBetween={16}
            slidesPerView={1}
            className="px-4"
          >
            {filteredtraining?.map((event) => (
              <SwiperSlide key={event._id}>

                <div
                  className="
                    group flex flex-col
                    bg-[#0a0a0a]
                    border border-white/10
                    rounded-2xl overflow-hidden
                  "
                >
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={IMAGE_URL + event.image}
                      alt={event.title}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  </div>

                  <div className="flex flex-col flex-1 p-5 space-y-3">
                    <h3 className="text-lg font-bold">{event.title}</h3>

                    <p className="text-sm text-gray-300 line-clamp-2">
                      {event.description}
                    </p>

                   <a
                  href={event.button_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
                    group
                    mt-auto
                    flex items-center justify-center gap-2
                    py-3 px-5
                    rounded-full
                    font-semibold text-white
                    bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                    transition-all
                  "
                >
                  Register Now

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="w-5 h-5 transition-transform group-hover:translate-x-1"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </a>

                  </div>
                </div>

              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* ================= DESKTOP GRID (UNCHANGED) ================= */}
        <div
          className="
            hidden lg:grid
            grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
            gap-x-6 gap-y-6
            mx-0 lg:mx-14
          "
        >
          {filteredtraining?.map((event) => (
            <div
              key={event._id}
              className="
                group flex flex-col
                bg-[#0a0a0a] backdrop-blur-xl
                border border-white/10
                rounded-2xl overflow-hidden
                transition-all duration-300
                hover:shadow-[0_0_30px_rgba(245,95,255,0.25)]
                hover:-translate-y-1
                w-full w-[380px]
                mx-0 lg:mx-auto
              "
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={IMAGE_URL + event.image}
                  alt={event.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
              </div>

              <div className="flex flex-col flex-1 p-5 space-y-3">
                <h3 className="text 👉bold">{event.title}</h3>

                <p className="text-sm text-gray-300 line-clamp-2">
                  {event.description}
                </p>

              <a
              href={event.button_link}
              target="_blank"
              rel="noopener noreferrer"
              className="
                group
                mt-auto
                flex items-center justify-center gap-2
                py-3 px-5
                rounded-full
                font-semibold text-white
                bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                hover:opacity-90
                transition
              "
            >
              Register Now

              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="w-5 h-5 transition-transform group-hover:translate-x-1"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </a>

              </div>
            </div>
          ))}
        </div>
      </>
      )}


          </motion.div>
          </AnimatePresence>

        </div>
      </motion.section>


  {/* <motion.section
  variants={sectionReveal}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-80px" }}
  className="relative bg-black py-24 overflow-hidden"
>

  <div className="relative z-10 max-w-7xl mx-auto px-6">

    <div className="max-w-3xl mb-16">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight mb-6 text-white">
      Unlock 1000+ Proven{" "}
      <span className="gradient-text">
        AI
      </span>
      <br />
      <span className="gradient-text">
        Prompts
      </span>
    </h2>


      <p className="text-[#ffffff80] text-lg mb-6">
        Forget random prompts and messy results. This is a carefully built
        library designed to boost creativity, save hours, and get real work
        done—whether you're writing content, designing visuals, or automating tasks.
      </p>

     <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 mb-10">
        {[
          "Instant Access to 1000+ Ready-to-Use AI Prompts",
          "Boost Productivity & Save Hours",
          "Made for Real-World Daily Use",
        ].map((item, i) => (
          <li
            key={i}
            className={`
              flex items-center gap-3 text-white
              ${i === 2 ? "sm:col-span-2" : ""}
            `}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-4 h-4 text-[#e12f5b] shrink-0"
              aria-hidden="true"
            >
              <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
              <path d="M20 2v4" />
              <path d="M22 4h-4" />
              <circle cx="4" cy="20" r="2" />
            </svg>

            <span className="text-[#ffffffb3] text-sm">{item}</span>
          </li>
        ))}
      </ul>


            <button
        className="
          px-6 py-3
          rounded-2xl
          font-semibold text-white
          bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
          flex items-center gap-2         
          hover:scale-105 transition-all duration-300
          shadow-[0_0_30px_rgba(245,95,255,0.35)]
          group                           
        "
      >
        Explore Prompt Library
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-5 h-5 transition-transform group-hover:translate-x-1"
          aria-hidden="true"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </button>


    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {cards.map((card, i) => (
        <div
          key={i}
          className="
            group bg-white/5 border border-white/10
            rounded-2xl overflow-hidden backdrop-blur-md
            transition-all duration-300
            hover:shadow-[0_0_30px_rgba(245,95,255,0.25)]
            hover:-translate-y-1
          "
        >
          <div className="relative">
            <img src={card.img} className="w-full h-44 object-cover" />

            <span className="absolute top-3 left-3 text-xs px-3 py-1 rounded-full bg-black/70 text-white">
              {card.title}
            </span>

            {card.tag === "Premium" && (
              <span className="absolute top-3 right-3 text-xs px-3 py-1 rounded-full bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] text-white">
                ✨ Premium
              </span>
            )}
          </div>

          <div className="p-4">
            <p className="text-sm text-gray-300 mb-4 line-clamp-2">
              A carefully crafted AI prompt designed for high-quality results.
            </p>

            <div className="flex items-center justify-between">
             <span
            className="
              inline-flex items-center
              px-3 py-1
              text-[11px] font-semibold uppercase tracking-wide

              rounded-full
              bg-white/10
              text-white

              shadow-[0_2px_10px_rgba(0,0,0,0.6)]
            "
          >
            {card.tag}
          </span>


              {card.tag === "Premium" ? (
               <button
                className="
                  inline-flex items-center gap-2
                  px-4 py-2
                  text-sm font-semibold
                  rounded-lg
                  text-white
                  bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                  hover:scale-105 transition-all
                  shadow-[0_0_18px_rgba(245,95,255,0.45)]
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-4 h-4"
                  aria-hidden="true"
                >
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>

                Unlock Premium
              </button>

              ) : (
                <button className="px-4 py-2 text-sm rounded-lg bg-white/10 text-white hover:bg-white/20">
                  Copy Prompt
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>

  </div>
</motion.section> */}


    
      

      <div className=''>
       
       
        <div>
          {
            (data?.section8_status === "Active") && <>
                <motion.section
                  variants={sectionReveal}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, margin: "-80px" }}
                  className="bg-black py-20 pt-24 px-4 relative overflow-hidden"
                >

                <div className="relative z-10 max-w-7xl mx-auto text-center">
                  <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight">
                 
                    {data?.section8_heading} &nbsp;
                    <span className="text-transparent bg-clip-text gradient-text">
                      {data?.section8_heading2}
                    </span>
                  </h1>
                  <p className="text-[#ffffff80] max-w-2xl mx-auto text-lg md:text-lg mb-12">
                    {/* Hear how creators like you are transforming with our AI-powered training. */}
                    {data?.section8_description}
                  </p>

                
                  <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-10">
                    {additionalData && additionalData?.youtubeData?.map((video, index) => (
                      <div
                        key={index}
                        className="rounded-2xl overflow-hidden shadow-xl shadow-[#00C6FF]/4 hover:shadow-[#00C6FF]/30 transition-shadow duration-300 border border-white/10 bg-white/5 backdrop-blur-md"
                      >
                        <div className="aspect-video w-fullrounded-2xl overflow-hidden">
                          <ReactPlayer
                            url={video?.youtube_link}
                            width="100%"
                            height="100%"
                            controls
                            className="react-player"
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Text Testimonials */}
         <div className="relative max-w-4xl mx-auto mt-20 px-4">

  {additionalData?.learnersData
    ?.slice(page2, page2 + 1)
    .map((t, i) => (

      <div
        key={page2}
        className="
          relative
          p-10 md:p-12
          rounded-2xl
          bg-[#0a0a0a] backdrop-blur-xl
          border border-white/10
          text-white text-left
        "
      >

        {/* QUOTE ICON */}
        <div className="mb-5 text-[#e12f5b] select-none">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" strokeWidth="2"
            className="w-10 h-10">
            <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/>
            <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/>
          </svg>
        </div>

        {/* DESCRIPTION */}
        <p className="text-[18px] md:text-[20px] leading-relaxed text-white/90 mb-10 max-w-3xl">
          {t.description}
        </p>

        {/* FOOTER */}
        <div className="flex items-center justify-between mt-4">

          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full overflow-hidden border border-white/20 bg-white/5">
              <img
                src={IMAGE_URL + t.image}
                alt={t.name}
                className="w-full h-full object-cover"
              />
            </div>

            <div>
              <p className="font-semibold text-lg">{t.name}</p>
              <p className="text-xs text-white/60">{t.course}</p>

              <div className="flex gap-1 mt-0.5">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-yellow-400 text-lg">★</span>
                ))}
              </div>
            </div>
          </div>

          {/* ARROWS */}
          <div className="flex gap-2">
            <button onClick={() => paginate1(-1)}
              className="w-10 h-10 rounded-full bg-white/10 border border-white/20 hover:bg-white/20">
              ‹
            </button>

            <button onClick={() => paginate1(1)}
              className="w-10 h-10 rounded-full bg-white/10 border border-white/20 hover:bg-white/20">
              ›
            </button>
          </div>

        </div>

        {/* DOTS */}
        <div className="flex justify-center gap-2 mt-10">
          {Array.from({ length: totalPages  }).map((_, i) => (
            <button
              key={i}
              onClick={() => setPage2([i, 0])}
              className={`h-2 rounded-full transition-all ${
                i === page2
                  ? "w-6 bg-[#f55fff]"
                  : "w-2 bg-white/30 hover:bg-white/50"
              }`}
            />
          ))}
        </div>

      </div>
    ))}
</div>

                </div>
              </motion.section>
            </>
          }


          {
            (data?.section9_status === "Active") && <>
              <div className="bg-black pb-14 pt-14 px-4 py-12 pt-24 relative overflow-hidden">
            
          <motion.section
              variants={sectionReveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 md:px-10 text-white"
            >
              {/* HEADING */}
              <h3 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-2">
                {data?.section9_heading}{" "}
                <span className="gradient-text">
                  {data?.section9_heading2}
                </span>
              </h3>

              <p
              className="
                text-center
                text-[#ffffff80]
                text-[20px]      
                sm:text-lg       
                mb-16
              "
            >
              {data?.section9_subheading}
            </p>

              {/* FAQ GRID */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {additionalData?.faqData?.map((faq, index) => {
                  const isOpen = openIndex === index;

                  return (
                    <div
                      key={index}
                      className={`
                        rounded-2xl border transition-all duration-300
                  bg-[rgb(10_10_10/var(--tw-bg-opacity))] border-white/10
                        ${
                          isOpen
                            ? "bg-[rgb(10_10_10/var(--tw-bg-opacity))] border-white/10"
                            : "bg-[rgb(10_10_10/var(--tw-bg-opacity))] border-white/10"
                        }
                      `}
                    >
                      {/* HEADER */}
                      <button
                        onClick={() => toggleFAQ(index)}
                        className="w-full px-4 py-5 flex items-center justify-between text-left rounded-2xl"
                      >
                        <span
                        className="
                           text-[17px]
                      sm:text-base
                      font-semibold
                      text-white
                      leading-snug
                      pr-2
                        "
                      >
                        {faq.question}
                      </span>


                        <span
                          className={`
                            flex-shrink-0
                      flex items-center justify-center
                      w-8 h-8 rounded-full
                      transition-all duration-300
                            ${
                              isOpen
                              ? "rotate-180 bg-white/10 text-red-500"
                              : "bg-white/10 text-white/60"

                            }
                          `}
                        >
                          <span className="text-xl leading-none">
                        {isOpen ? "−" : "+"}
                      </span>
                        </span>
                      </button>

                      {/* ANSWER */}
                      <div
                      className={`overflow-hidden transition-all duration-300 px-4
                        ${isOpen ? "max-h-[420px] pb-4" : "max-h-0"}
                      `}
                    >
                      {isOpen && (
                        <div
                          className="
                            pt-1
                            text-[17px]        
                            sm:text-base       
                            text-[#fff9]
                            leading-relaxed
                          "
                        >
                          {faq.answer}
                        </div>
                      )}
                    </div>

                    </div>
                  );
                })}
              </div>
            </motion.section>
              </div>
            </>
          }

           <motion.section
          variants={sectionReveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="relative bg-black py-14 sm:py-20 overflow-hidden"
        >

              <div className="relative z-10 w-full px-0">

              
               <h3 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-2">
                Master the{" "}
                <span className="gradient-text">
                  Best AI Tools
                </span>
              </h3>

              <p className="text-center text-gray-400 text-sm sm:text-base md:text-lg mb-8 max-w-xl mx-auto">
                Learn from industry experts
              </p>


                {/* 🔁 ROW 1 — RIGHT ➝ LEFT */}
                <div className="tools-marquee mb-6">
                  <div className="tools-track rtl">
                    {marqueeTools.map((tool, i) => (
                      <div key={`row1-${i}`} className="tool-card">
                        <img src={tool.icon} alt={tool.name} />
                        <span>{tool.name}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* 🔁 ROW 2 — LEFT ➝ RIGHT */}
                <div className="tools-marquee">
                  <div className="tools-track ltr">
                    {marqueeTools1.map((tool, i) => (
                      <div key={`row2-${i}`} className="tool-card">
                        <img src={tool.icon} alt={tool.name} />
                        <span>{tool.name}</span>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </motion.section>

      <motion.section
          variants={sectionReveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="relative bg-black py-24 overflow-hidden"
        >
          <div className="relative z-10 max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">

          {/* NAME + SOCIAL */}
        <div className="relative flex justify-center">

          {/* IMAGE CARD */}
          <div
              className="
              relative
              w-[400px]
              md:w-[450px]
              mx-auto
              aspect-[3/4]
              rounded-[32px]
              overflow-hidden
              bg-[rgb(14_14_14)]
              border border-white/10
              shadow-[0_0_90px_rgba(0,0,0,0.65)]
            "
          >
            <motion.span
              animate={{ y: [0, -6, 0] }}
              transition={{ duration: 2, ease: "easeInOut", repeat: Infinity }}
              className="
                absolute top-2 right-2
                z-30
                px-4 py-1
                text-xs sm:text-sm
                font-semibold
                
                rounded-full
                text-white
                bg-gradient-to-r from-[#ff3366] via-[#a855f7] to-[#3b82f6]
                shadow-[0_6px_24px_rgba(244,63,143,0.6)]
              "
            >
             {data?.section10_top_badge}
            </motion.span>
            <img
              //src="/images/founderdemopic.jpg"
              //src="courses-hero-banner.png" 
               src={IMAGE_URL + data?.section10_image}
              alt="Satyam – Founder"
              className="absolute inset-0 w-full h-full object-contain object-center"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

            <div className="absolute bottom-7 left-7 text-white">
              <h3 className="text-2xl font-bold leading-tight"> {data?.section10_left_name}</h3>
              <p className="text-sm font-medium text-[#ff3366]">
               {data?.section10_left_detail}
              </p>

              <div className="flex gap-3 mt-3">

              <a
                href="https://www.youtube.com/@SatyamTechInsights"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 text-lg rounded-full bg-white/15 hover:bg-[#FF0000]
                  flex items-center justify-center transition-all duration-200"
              >
                <FaYoutube />
              </a>

              <a
                href="https://www.instagram.com/satyamtechinsights/"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 text-lg rounded-full bg-white/15 hover:bg-[#E1306C]
                  flex items-center justify-center transition-all duration-200"
              >
                <FaInstagram />
              </a>

              <a
                href="https://www.facebook.com/satyamtechinsights"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 text-lg rounded-full bg-white/15 hover:bg-[#1877F2]
                  flex items-center justify-center transition-all duration-200"
              >
                <FaFacebook />
              </a>

              <a
                href="https://www.whatsapp.com/channel/0029Vb5TDJXHbFUy2QPDL442"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 text-lg rounded-full bg-white/15 hover:bg-[#25D366]
                  flex items-center justify-center transition-all duration-200"
              >
                <FaWhatsapp />
              </a>

              <a
                href="https://t.me/+7kjQsrSXmPc3OTll"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 text-lg rounded-full bg-white/15 hover:bg-[#0088cc]
                  flex items-center justify-center transition-all duration-200"
              >
                <FaTelegramPlane />
              </a>

              <a
                href="https://www.threads.com/@satyamtechinsights"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 text-lg rounded-full bg-white/15 hover:bg-white hover:text-black
                  flex items-center justify-center transition-all duration-200"
              >
                <SiThreads />
              </a>
            
          </div>

            </div>
          </div>
        </div>

              {/* 🧠 RIGHT CONTENT */}
              <div className="text-white">
                <p className="text-sm font-semibold uppercase tracking-[0.05em] text-[#ff3366] mb-4">
               {data?.section10_founder_title}
              </p>


                <h2
                className="
                  text-[36px]          /* 🔽 mobile smaller */
                  sm:text-[44px]       /* tablet same as pehle mobile */
                  md:text-[50px]       /* desktop same */
                  font-extrabold
                  leading-[1.0]
                  mb-6
                "
              >
               {data?.section10_title1}{" "}
                <span className="gradient-text">
                 {data?.section10_title2}
                </span>
              </h2>


                <p className="text-[#fff9] leading-relaxed text-lg font-medium max-w-xl mb-6">
               {data?.section10_description1}
          </p>


                <p className="text-[#fff9] leading-relaxed font-medium max-w-xl mb-6">
                {data?.section10_description2}
                </p>

                {/* 📊 STATS */}
                <div className="grid grid-cols-2 gap-6 max-w-xl">
            {[
              {
                value:  data?.section10_box1,
                label: "Community Members",
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-6 h-6 mb-2 text-[#f43f8f]"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <circle cx="9" cy="7" r="4" />
                  </svg>
                ),
              },
              {
                value: data?.section10_box2,
                label: "Content Reach",
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-6 h-6 mb-2 text-[#f43f8f]"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                    <path d="M2 12h20" />
                  </svg>
                ),
              },
              {
                value: data?.section10_box3,
                label: "AI Expert",
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-6 h-6 mb-2 text-[#f43f8f]"
                  >
                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                    <circle cx="12" cy="8" r="6" />
                  </svg>
                ),
              },
              {
                value: data?.section10_box4,
                label: "Students Trained",
                icon: (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-6 h-6 mb-2 text-[#f43f8f]"
                  >
                    <path d="M16 7h6v6" />
                    <path d="m22 7-8.5 8.5-5-5L2 17" />
                  </svg>
                ),
              },
            ].map((stat, i) => (
              <div
                key={i}
                className="
                  bg-[rgb(14_14_14)]
                  border border-white/10
                  rounded-2xl
                  px-6 py-5
                  backdrop-blur-md
                "
              >
                {stat.icon}

                <h3 className="text-2xl font-extrabold gradient-text">
                  {stat.value}
                </h3>

                <p className="text-sm text-gray-400 mt-1">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>

              </div>

            </div>
          </motion.section>

      <motion.section
  variants={sectionReveal}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-80px" }}
  className="relative bg-black py-16 sm:py-20 overflow-hidden"
>
  <div
    className="
      relative z-10
      max-w-7xl mx-auto
      px-3 sm:px-6
      rounded-[28px]
      border border-white/10
      bg-white/3 backdrop-blur-xl
    "
  >
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center p-4 sm:p-8 lg:p-12">

     

      {/* 🖼️ LEFT IMAGE + STATS — MOBILE SECOND */}
      <div className="flex flex-col items-center w-full order-2 lg:order-1">
      <div className="block lg:hidden">
        <h2 className="text-3xl sm:text-4xl font-extrabold leading-tight mb-4">
          {data?.section11_title}{" "}
          <span className="bg-gradient-to-r from-[#436cff] to-[#e1307a] bg-clip-text text-transparent">
             {data?.section11_title1}
          </span>
        </h2>

        <p className="text-sm sm:text-sm text-gray-400 mb-10 max-w-xl">
         {data?.section11_description}
        </p>
      </div>

        <div className="w-full sm:w-[360px] md:w-[420px] lg:w-[460px] mb-3">
          <span className="
            inline-flex items-center gap-2
            px-4 py-2
            rounded-full
            text-sm font-medium
            text-[#ff3366]
            border border-[#262626]
            bg-black/60 backdrop-blur
          ">
             {data?.section11_top_badge}
          </span>
        </div>

        <div className="
          relative
          w-full sm:w-[360px] md:w-[420px] lg:w-[460px]
          aspect-[4/3]
          overflow-visible
        ">
          <div className="
            relative w-full h-full
            rounded-2xl sm:rounded-3xl
            overflow-hidden
            border border-white/10
            bg-black
          ">
            <img
             // src="/images/community.jpg"
              src={IMAGE_URL + data?.section11_image}
              alt="AI Community"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-black/20 to-transparent" />
          </div>
        </div>

        {/* Stats */}
        <div className="pt-6 border-t border-white/10 grid grid-cols-3 text-center gap-6">
          {[
            { v: data?.section11_members, l: "Members" },
            { v: data?.section11_prompts, l: "Prompts" },
            { v: data?.section11_updated, l: "Updates" },
          ].map((s, i) => (
            <div key={i} className="space-y-1">
              <p className="text-2xl sm:text-3xl font-extrabold gradient-text">
                {s.v}
              </p>
              <p className="text-xs sm:text-sm text-gray-400 tracking-wide">
                {s.l}
              </p>
            </div>
          ))}
        </div>

      </div>

       {/* 🧠 RIGHT CONTENT — MOBILE FIRST */}
      <div className="w-full text-white order-3 lg:order-2">

        <div className="hidden lg:block">
        <h2 className="text-2xl sm:text-4xl font-extrabold leading-tight mb-4">
           {data?.section11_title}{" "}
          <span className="bg-gradient-to-r from-[#436cff] to-[#e1307a] bg-clip-text text-transparent">
           {data?.section11_title1}
          </span>
        </h2>

        <p className="text-xs sm:text-sm text-gray-400 mb-10 max-w-xl">
         {data?.section11_description}
        </p>
      </div>


        {/* 🔥 GLASS CARD */}
        <div
          className="
            relative
            rounded-2xl sm:rounded-3xl
            p-5 sm:p-8 lg:p-10
            bg-black/60
            backdrop-blur-xl
            border border-white/10
          "
        >
          <div
            className="
              absolute -top-5 -right-5
              w-12 h-12 sm:w-14 sm:h-14
              rounded-2xl
              bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
              flex items-center justify-center
            "
          >
            <FaUsers className="text-white text-lg sm:text-xl" />
          </div>

          <h3 className="text-lg sm:text-2xl font-bold mb-5">
           {data?.section11_heading}
          </h3>

         <ul className="space-y-3 sm:space-y-4 mb-8 sm:mb-10">
          {data?.section11_points
            ?.replace(/<p><br><\/p>/g, "") // ❌ empty p remove
            ?.replace(/<\/p>/g, "")
            ?.split("<p>")
            ?.filter((item) => item.replace(/&nbsp;|\s/g, "") !== "") // ✅ empty text remove
            .map((item, i) => (
              <li key={i} className="flex gap-3">
                <span className="mt-1 w-5 h-5 rounded-full bg-[#f55fff]/20 text-[#f55fff] flex items-center justify-center text-xs">
                  ✓
                </span>
                <span
                  className="text-sm sm:text-base text-gray-300"
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </li>
            ))}
        </ul>



          <a
            href= {data?.section11_button_link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:max-w-[320px]"
          >
            <button
              className="
                group
                mt-5
                w-full
                px-6 py-4          /* 🔥 mobile me bada */
                sm:px-8 sm:py-3.5  /* desktop me normal */
                rounded-full
                font-semibold
                text-white
                bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                hover:scale-[1.03]
                transition-all
                flex items-center justify-center gap-2
              "
            >
              {data?.section11_button}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-5 h-5 transition-transform group-hover:translate-x-1"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </button>
          </a>
        </div>
      </div>

    </div>
  </div>
</motion.section>


          
        <motion.section
              variants={sectionReveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="relative relative pt-12 pb-10 sm:pt-16 sm:pb-14 bg-black py-12 sm:py-16 overflow-hidden"
            >
                  <div className="max-w-[80rem] mx-auto px-5 relative">
                    <div className="rounded-2xl border border-white/10 overflow-hidden">
                      <div
                        className="relative z-10 text-white rounded-2xl shadow-2xl backdrop-blur-md overflow-hidden"
                        style={{
                          // backgroundImage:
                          //   "linear-gradient(rgba(0, 2, 69, 0.69), rgba(0, 16, 53, 0.43), rgba(36, 1, 78, 0.23), rgba(0, 44, 201, 0.31)), url('/bg-g.svg')",
                          backgroundPosition: "center center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                        }}
                      >
                        {/* GRID */}
                        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start md:items-center">
                
                          {/* LEFT IMAGE */}
                          <div className="flex justify-center md:justify-start">
                            <img
                              //src="https://tagmango.com/publicassets/-all-in-one--combo-10-ai-courses-840fb11c320a44c311b84ee74c4d7d78.png"
                              src={IMAGE_URL + data?.section12_image}
                              alt="10-in-1 AI Combo"
                              className="w-full max-w-[420px] md:max-w-[480px] drop-shadow-2xl"
                              
                            />
                          </div>
                
                          {/* RIGHT CONTENT */}
                          <div className="
                        text-center md:text-left
                        px-4 sm:px-6 md:px-0
                        pb-6 sm:pb-8 md:pb-0
                      ">
                        <h2 className="
                        text-[18px] sm:text-[38px]
                        font-extrabold text-white mb-3
                        flex items-center justify-center md:justify-start gap-2
                        whitespace-nowrap
                      ">
                        <FaBolt className="text-white animate-pulse shrink-0" />
                        <span className="truncate">
                          {data?.section12_heading}
                        </span>
                      </h2>


                        <p className="text-gray-300 max-w-xl mb-5 sm:mb-6 text-sm sm:text-base">
                           {data?.section12_description}
                        </p>

                      <a
                    target="_blank"
                    href= {data?.section12_button_link}
                    className="
                      group
                      inline-flex items-center justify-center gap-2

                      px-9 py-4
                      sm:px-8 sm:py-3.5

                      rounded-full
                      font-semibold
                      text-white
                      text-base sm:text-sm

                      bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                      hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)]
                      transition-all duration-300
                      shadow-lg
                    "
                  >
                    <FaGift className="text-yellow-300 text-xl sm:text-lg" />

                   {data?.section12_button}

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="w-5 h-5 transition-transform group-hover:translate-x-1"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </a>




                        <p className="mt-4 text-sm sm:text-base text-gray-300">
                          {data?.section12_text1} <span className="text-yellow-400 font-bold">{data?.section12_text2}</span> {data?.section12_text3}
                        </p>
                      </div>

                
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.section>


        </div>

      </div>
      <Footer />
      <MobileFooter />
    </div>
  );
};

export default Home3;
